import React from "react";
import { Control } from "react-hook-form";

import { SupplierSelect } from "../../form_components/SupplierSelect";
import { FrameworkFilters } from "../utils";

import css from "./SharedFilterGroups.module.scss";

type Props = {
  control: Control<FrameworkFilters, unknown>;
};

function SuppliersFilterContent({ control }: Props) {
  return (
    <div className={css.filterSection} aria-label="Supplier filters">
      <SupplierSelect name="supplierIds" label="Supplier Guids" control={control} />
    </div>
  );
}

export default SuppliersFilterContent;
